/* 18.10.2026 (024): Diese Datei bindet jede em-Section ueber em-assets ein —
   auf der Wuerfel-Seite 11-mal. Ohne Sperre lief alles 11-mal: 11 Scroll-
   Handler fuer die Skizzen, 11 fuer die Tuerchen, je Bild 11 Layout-Lesungen.
   Alle Teile warten ohnehin auf DOMContentLoaded, die erste Ausfuehrung
   reicht also. Reihenfolge und Ladeort bleiben unveraendert (kein defer —
   siehe Hinweis in snippets/em-assets.liquid). */
if (!window.__em2026Geladen) {
window.__em2026Geladen = true;
/* =========================================================================
   em-2026.js — Bewegung beim Scrollen.

   Sicherheitsprinzip: Das CSS versteckt NUR Elemente, die .reveal tragen.
   Diese Klasse vergibt erst dieses Skript. Faellt das Skript aus, ist die
   Seite vollstaendig sichtbar — nur ohne Animation.
   ========================================================================= */
(function () {
  "use strict";

  var ruhig = window.matchMedia &&
              window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (ruhig || !("IntersectionObserver" in window)) return;

  /* Was sich bewegen soll — je Abschnitt, in Lesereihenfolge */
  var AUSWAHL = [
    ".em-eyebrow", ".em-display", ".em-h2", ".em-h3", ".em-lede",
    ".em-s > .em-wrap > p", ".em-list", ".em-usp__grid > *",
    ".em-review", ".em-faq__item", ".em-adv__door", ".em-swatch",
    ".em-trustbar__row > *", ".em-card", ".em-buy__frame", ".em-thumbs",
    ".em-home-rev", ".em-count", ".em-chip", ".em-facts__num", ".em-linie__pt"
  ].join(",");

  function vorbereiten() {
    var abschnitte = document.querySelectorAll(".em-s");
    if (!abschnitte.length) return [];

    var alle = [];
    Array.prototype.forEach.call(abschnitte, function (sec) {
      var treffer = sec.querySelectorAll(AUSWAHL);
      var n = 0;
      Array.prototype.forEach.call(treffer, function (el) {
        if (el.closest(".em-btn, .em-cta") && !el.matches(".em-btn, .em-cta")) return;
        if (el.dataset.emRev) return;
        el.dataset.emRev = "1";
        el.classList.add("reveal");
        el.style.setProperty("--i", n++);
        alle.push(el);
      });
    });
    return alle;
  }

  function beobachten(elemente) {
    var beob = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        beob.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });

    elemente.forEach(function (el) {
      /* Was beim Laden schon im Bild ist, wird sofort gezeigt —
         sonst blitzt der obere Seitenbereich leer auf. */
      /* Der erste Bildschirm animiert nie — sonst blitzt er beim Laden
         leer auf. Grosszuegig gerechnet, damit es auf hohen Schirmen
         genauso sitzt wie auf niedrigen. */
      var r = el.getBoundingClientRect();
      var absOben = r.top + (window.scrollY || 0);
      if (absOben < Math.max(window.innerHeight * 1.05, 760)) {
        el.classList.add("is-in");
        return;
      }
      beob.observe(el);
    });

    /* Sprung nach unten (Ankerlink, Zurueck-Taste, schnelles Scrollen)
       darf nichts unsichtbar zuruecklassen: alles oberhalb der Sichtkante
       wird nachgezogen. */
    var laeuft = false;
    function nachziehen() {
      laeuft = false;
      var grenze = window.innerHeight * 0.92;
      elemente.forEach(function (el) {
        if (el.classList.contains("is-in")) return;
        if (el.getBoundingClientRect().top < grenze) {
          el.classList.add("is-in");
          beob.unobserve(el);
        }
      });
    }
    window.addEventListener("scroll", function () {
      if (laeuft) return;
      laeuft = true;
      window.requestAnimationFrame(nachziehen);
    }, { passive: true });
  }

  function start() {
    var el = vorbereiten();
    if (el.length) beobachten(el);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  /* Sections, die der Theme-Editor nachlaedt, mitnehmen */
  document.addEventListener("shopify:section:load", start);
})();

/* ---------------------------------------------------------------------
   Hintergrund-Skizzen einsetzen.
   Fest verdrahtet je Abschnitt, damit bei jedem Aufruf dasselbe steht —
   nichts springt beim Neuladen.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  var PLAN = {
    em_buybox:   [["riegel", "4%", "62%", 150, -9], ["flocke", "78%", "12%", 110, 12]],
    em_trustrow: [["kugel", "79%", "18%", 90, 8]],
    em_story:    [["tafel", "4%", "12%", 140, -8], ["herz", "78%", "58%", 110, 12],
                  ["stern", "72%", "6%", 80, -14]],
    em_tuerchen: [["zweig", "4%", "8%", 150, -6], ["stern", "80%", "22%", 95, 10],
                  ["stange", "6%", "76%", 120, 14]],
    em_reviews:  [["herz", "5%", "14%", 130, -10], ["stern", "79%", "70%", 100, 8]],
    em_midcta:   [["kugel", "8%", "22%", 100, 6], ["flocke", "78%", "16%", 95, -8]],
    em_usp:      [["tafel", "79%", "10%", 130, 10], ["riegel", "4%", "66%", 145, -12]],
    em_fuerwen:  [["zweig", "79%", "12%", 130, 9], ["herz", "4%", "64%", 105, -8]],
    em_faq:      [["flocke", "80%", "20%", 100, 7]],
    /* Startseite (012) */
    em_kalender:  [["stern", "82%", "8%", 90, 10], ["zweig", "3%", "66%", 130, -6]],
    em_highlight: [["herz", "84%", "12%", 100, 8]],
    em_kategorien:[["flocke", "3%", "10%", 90, -8]],
    em_probier:   [["kugel", "82%", "18%", 95, 6]],
    em_close:    [["zweig", "4%", "14%", 140, -7], ["stange", "78%", "60%", 120, 11],
                  ["stern", "74%", "10%", 85, -13], ["kugel", "10%", "72%", 95, 9]]
  };

  function setzen() {
    Object.keys(PLAN).forEach(function (schluessel, si) {
      var sek = document.querySelector('.shopify-section[id$="__' + schluessel + '"]');
      if (!sek || sek.querySelector(":scope > .em-deko")) return;
      var huelle = document.createElement("div");
      huelle.className = "em-deko";
      huelle.setAttribute("aria-hidden", "true");
      PLAN[schluessel].forEach(function (m, i) {
        var e = document.createElement("span");
        e.className = "em-deko__i em-deko__i--" + m[0];
        e.style.setProperty("--x", m[1]);
        e.style.setProperty("--y", m[2]);
        e.style.setProperty("--gr", m[3] + "px");
        e.style.setProperty("--dreh", m[4] + "deg");
        e.style.setProperty("--dauer", (12 + ((si + i) % 5) * 2.5) + "s");
        e.style.setProperty("--verzug", ((si + i * 3) % 7) * -1.3 + "s");
        huelle.appendChild(e);
      });
      sek.insertBefore(huelle, sek.firstChild);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setzen);
  } else {
    setzen();
  }
})();

/* ---------------------------------------------------------------------
   Tiefe: die Skizzen wandern beim Scrollen langsamer als die Seite.
   Nur ueber requestAnimationFrame, nie direkt im Scroll-Ereignis.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var teile = [], laeuft = false;

  function sammeln() {
    teile = [].slice.call(document.querySelectorAll(".em-deko__i")).map(function (e, i) {
      return { e: e, tempo: 0.06 + (i % 4) * 0.035 };
    });
  }

  function zeichnen() {
    laeuft = false;
    var mitte = window.innerHeight / 2;
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i], r = t.e.getBoundingClientRect();
      if (r.bottom < -300 || r.top > window.innerHeight + 300) continue;
      t.e.style.setProperty("--schub", Math.round((mitte - (r.top + r.height / 2)) * t.tempo) + "px");
    }
  }

  function anstossen() {
    if (laeuft) return;
    laeuft = true;
    window.requestAnimationFrame(zeichnen);
  }

  function start() { sammeln(); zeichnen(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  window.addEventListener("scroll", anstossen, { passive: true });
  window.addEventListener("resize", function () { sammeln(); anstossen(); }, { passive: true });
})();

/* ---------------------------------------------------------------------
   Tuerchen oeffnen.
   Fest verdrahtet nach Position, damit beim Neuladen nichts springt:
   jedes Foto-Tuerchen steht offen, jedes vierte Zahlen-Tuerchen einen
   Spalt. Die leichte Drehung bricht das Raster auf.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  var SPALT = [0, 3, 7, 10, 15, 19];   /* Positionen im Raster, nullbasiert */
  var KIPP  = [-1.1, .8, -.6, 1.2, .5, -.9, 1, -.7];

  function oeffnen() {
    var tueren = document.querySelectorAll(".em-adv__door");
    if (!tueren.length) return;
    [].forEach.call(tueren, function (t, i) {
      if (t.classList.contains("em-adv__door--auf")) return;
      var hatFoto = t.classList.contains("em-adv__door--photo") || !!t.querySelector("img");
      if (hatFoto) {
        t.classList.add("em-adv__door--auf");
      } else if (SPALT.indexOf(i) > -1) {
        t.classList.add("em-adv__door--auf", "em-adv__door--spalt");
      }
      t.style.setProperty("--kipp", KIPP[i % KIPP.length] + "deg");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", oeffnen);
  } else {
    oeffnen();
  }
})();

/* ---------------------------------------------------------------------
   Die Tueren folgen dem Scrollen.
   Je weiter das Raster ins Bild kommt, desto weiter gehen sie auf —
   von links oben nach rechts unten, jede mit etwas Versatz. Wer
   zurueckscrollt, schliesst sie wieder.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  var ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var raster, tueren, laeuft = false;

  function sammeln() {
    raster = document.querySelector(".em-adv__grid");
    tueren = raster ? [].slice.call(raster.querySelectorAll(".em-adv__door--auf")) : [];
  }

  function zeichnen() {
    laeuft = false;
    if (!raster || !tueren.length) return;
    var r = raster.getBoundingClientRect();
    /* 0 = Raster kommt gerade von unten herein, 1 = Mitte erreicht */
    var weg = window.innerHeight * 0.82;
    var fortschritt = (window.innerHeight - r.top) / (weg + r.height * 0.34);
    if (fortschritt < 0) fortschritt = 0;
    if (fortschritt > 1) fortschritt = 1;

    for (var i = 0; i < tueren.length; i++) {
      var t = tueren[i];
      var versatz = i / tueren.length * 0.45;              /* gestaffelt */
      var f = (fortschritt - versatz) / (1 - versatz);
      if (f < 0) f = 0;
      if (f > 1) f = 1;
      f = f * f * (3 - 2 * f);                              /* weich ein, weich aus */
      var ziel = parseFloat(t.style.getPropertyValue("--ziel") ||
                 getComputedStyle(t).getPropertyValue("--ziel")) || -50;
      t.style.setProperty("--tuer", (ziel * f).toFixed(1) + "deg");
      if (f > 0.55) { t.classList.add("is-offen"); } else { t.classList.remove("is-offen"); }
    }
  }

  function anstossen() {
    if (laeuft) return;
    laeuft = true;
    window.requestAnimationFrame(zeichnen);
  }

  function start() {
    sammeln();
    if (ruhig) return;          /* kein Scroll-Klappen, die Tueren stehen offen */
    zeichnen();
    window.addEventListener("scroll", anstossen, { passive: true });
    window.addEventListener("resize", function () { sammeln(); anstossen(); }, { passive: true });
  }

  /* laeuft nach dem Tuerchen-Oeffner, deshalb ein Tick spaeter */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { setTimeout(start, 0); });
  } else {
    setTimeout(start, 0);
  }
})();
}
